import { jsx as o } from "react/jsx-runtime";
import { memo as t } from "react";
import { u as i } from "./styled-components.browser.esm-3eb04950.js";
const p = t(({ text: e, color: r }) => /* @__PURE__ */ o("div", { style: {
  minWidth: "calc(100%)",
  padding: "0px 12px",
  backgroundColor: r,
  borderRadius: "6px"
}, children: /* @__PURE__ */ o(d, { style: {}, children: e }) })), d = i.div`
  white-space: nowrap;
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
  text-align: center;
`;
export {
  p as default
};
//# sourceMappingURL=ColorizedTag.js.map
